export enum SDKs {
  // Original SDKs
  LOCAL_CONTENT = "local-content",
  LOCAL_CONTENT_DEPRECATED = "local-content-deprecated",
  LOCAL_CONTENT_GOOGLE_MAPS = "local-content-google-maps",
  LOCAL_DEMOGRAPHICS = "local-demographics",

  // Neighborhood Wrap
  NEIGHBORHOOD_HERO = "neighborhood-hero",
  NEIGHBORHOOD_MAP = "neighborhood-map",
  NEIGHBORHOOD_CHARACTERISTICS = "neighborhood-characteristics",
  NEIGHBORHOOD_HIGHLIGHTS = "neighborhood-highlights",
  NEIGHBORHOOD_DEMOGRAPHICS = "neighborhood-demographics",
  NEIGHBORHOOD_PROPERTY_VALUE_DRIVERS = "neighborhood-property-value-drivers",
  NEIGHBORHOOD_MATCH = "neighborhood-match",
  NEIGHBORHOOD_MARKET_TRENDS = "neighborhood-market-trends",
  NEIGHBORHOOD_SCHOOLS = "neighborhood-schools",
  LEAD_CAPTURE = "lead-capture",

  // Local Logic Hub
  NEIGHBORHOOD_SHOWCASE = "neighborhood-showcase",
  NEIGHBORHOOD_FEATURED = "neighborhood-featured",
}
